import BaseApiService from '../BaseApiService';
import WebEnvConfig from '@/models/WebEnvConfig';
import IServiceHelper from './IServiceHelper';
import ServiceHelperFactory from './ServiceHelperFactory';

export default class NonProdExtrasService extends BaseApiService {
    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async getSmartExchangeUserToken(username: string | undefined, password: string | undefined): Promise<string> {
        let result = '';
        this.setIncludeAuthorization(true);

        const data = {
            username: `${username}`,
            password: `${password}`
        };

        const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/SmartExchangeUserLoginTokenForTesting', data);
        if (response.data) {
            result = response.data;
        }
        return result;
    }
}
